import { useCallback, useEffect, useRef, useState } from 'react';
import { AudienceOptions, errorText, getAudienceOptions } from './api';
export default function useAudienceOptions() {
  const [data, setData] = useState<AudienceOptions | null>(null), [loading, setLoading] = useState(true), [error, setError] = useState('');
  const active = useRef(true), version = useRef(0), abort = useRef<AbortController | null>(null);
  const reload = useCallback(async () => {
    const id = ++version.current; abort.current?.abort(); const controller = new AbortController(); abort.current = controller;
    setLoading(true); setError('');
    try {
      const result = await getAudienceOptions(controller.signal);
      if (!Array.isArray(result.countries) || !Array.isArray(result.languages)) throw new Error('Invalid audience options');
      if (active.current && id === version.current) setData(result);
    } catch (failure) { if (active.current && id === version.current) setError(errorText(failure)); }
    finally { if (active.current && id === version.current) setLoading(false); }
  }, []);
  useEffect(() => { active.current = true; reload(); return () => { active.current = false; version.current += 1; abort.current?.abort(); }; }, [reload]);
  return { data, loading, error, reload };
}
export function countryName(code: string) {
  if (!code || code === 'unknown') return 'Bilinmiyor';
  try { return new Intl.DisplayNames(['tr'], { type: 'region' }).of(code) || code; } catch { return code; }
}
